//creating face Customers Talks.....
const customers_Dummy_Talks = [
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
  {
    name: "Richa",
    date: "25/03/2022",
    rating: 5,
    description:
      "There was Leakage in my puriet RO from last 1 day so i loadged my purit service at  the company which is knewn as best purit service center in greater noida. Today Morning their expert manoj came and done my purit ro service. Thanks roservicecenter.live ",
  },
];

module.exports = customers_Dummy_Talks;
